<template>
  <div class="custom-main custom-theme">
    <a-row>
      <a-col :span="12">
        <a-form class="ant-advanced-search-form">
          <a-row class="searchrow width-style-auto">
            <a-button icon="search" @click="searchAction" style="margin-right: 10px;">刷新</a-button>
            <a-button type="primary" size="default" icon="plus-circle" @click="addAction">新增</a-button>
          </a-row>
        </a-form>
        <a-row class="search"></a-row>
        <a-table size="middle" :columns="grid.columns" :loading="grid.loading" :rowSelection="{fixed:true}" rowKey="id" :dataSource="grid.data"
                 :scroll="{ x: '100%' }" :pagination="false">
          <span slot="index" slot-scope="text, record, index">
            {{(index + 1) }}
          </span>
          <span slot="operate" slot-scope="text, record, index">
            <a href="javascript:;" @click="()=>empower(record.id)">赋权</a>
          </span>
        </a-table>
      </a-col>
      <a-col :span="12">
        <a-form :form="form" layout="horizontal" style="margin-top: 24px;">
          <a-row>
            <a-col>
              <a-form-item :colon="false" label="角色名称" :label-col="{sm: 5, md: 5, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 14, md: 14, lg: 13, xl: 13, xxl: 13 }">
                <a-input ref="name" v-decorator="['name', { rules: [{ required: true, message: '角色名称必须填写!' }], initialValue: record.name }]" placeholder="请输入角色名称"/>
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item :colon="false" label="角色描述" :label-col="{sm: 5, md: 5, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 14, md: 14, lg: 13, xl: 13, xxl: 13 }">
                <a-input v-decorator="['desc', { rules: [{ required: false, message: '角色名称必须填写!' }], initialValue: record.desc }]" placeholder="请输入角色描述"/>
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item :colon="false" label="菜单赋权" :label-col="{sm: 5, md: 5, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 14, md: 14, lg: 13, xl: 13, xxl: 13 }">
                <a-tree multiple checkable :show-line="true" @check="onTreeCheck" @select="onTreeSelect" v-model="modules" :selected-keys="selected" :tree-data="init.modules" :default-expand-all="true" style="max-height: 600px;overflow-y: auto;">
                </a-tree>
              </a-form-item>
            </a-col>
          </a-row>
          <div class="button-container">
            <div style="float: right">
              <a-button type="primary" style="margin-right: 240px;" @click="empowerAction">赋权</a-button>
            </div>
          </div>
        </a-form>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: "Role",
  data() {
    return {
      init:{
        modules:[]
      },
      modules:[],
      selected:[],
      grid:{
        loading: false,
        columns: columns,
        data:[]
      },
      form: this.$form.createForm(this),
      record:{
      }
    }
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    },{
      text: "医院管理",
      path: ""
    },{
      text: "角色管理",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  mounted(){
    const self = this;
    this.$axios.get('/api/clinic/module/trees').then(function (res) {
      if (res.msg.flag == 0) {
        if(null != res.biz && !res.biz.empty){
          res.biz.forEach(function (item, index) {
            self.init.modules.push({key: item.id, value: item.id, title:item.name, type:'T', children:self.children(item.children)});
          });
        }
      }
    }, function (res) {
    });

    this.searchAction();
  },
  methods:{
    addAction:function (){
      this.form.resetFields();
      this.record={};
      this.modules=[];
      this.selected=[];
      this.$refs.name.focus();
    },
    empowerAction:function (){
      const self = this;

      this.form.validateFields((err, values) => {
        if(!err){
          if(undefined == self.modules || null == self.modules || self.modules.length <=0){
            self.$message.error('请先设置角色的菜单权限.', 2);
            return false;
          }
          let params = {name:values.name, desc:values.desc, modules:self.modules};
          if(undefined != self.record && null != self.record && undefined != self.record.id
              && null != self.record.id && '' != self.record.id){
            params.id = self.record.id;
          }

          self.$axios.post('/api/clinic/role/empower', params).then(function(res){
            if(res.msg.flag == 0){
              self.$message.success({content: '角色赋权成功.', duration: 2});
              self.form.resetFields();
              self.modules = [];
              self.selected = [];
              self.record ={};
              self.searchAction();
            }else{
              self.$message.error({content: res.msg.message, duration: 2});
            }
          },function(res){
          });
        }
      });
    },
    onTreeCheck:function (checkedKeys, e){
      const self = this;
      this.modules=[];
      this.selected=[];
      if(checkedKeys.length > 0){
        e.checkedNodes.forEach(function (item){
          if(item.data.props.type == 'L'){
            self.modules.push(item.data.props.value);
            self.selected.push(item.data.props.value);
          }
        });
      }
      console.info('modules='+JSON.stringify(this.modules));
    },
    onTreeSelect:function (selectedKeys, e){
      const self = this;
      this.modules=[];
      this.selected=[];
      if(selectedKeys.length > 0){
        e.selectedNodes.forEach(function (item){
          if(item.data.props.type == 'L'){
            self.modules.push(item.data.props.value);
            self.selected.push(item.data.props.value);
          }
        });
      }
      console.info('modules='+JSON.stringify(this.modules));
    },
    empower:function (id){
      const self = this;
      this.$axios.get('/api/clinic/role/'+id).then(function (res) {
        if (res.msg.flag == 0) {
          if(null != res.biz){
            self.record = {id:res.biz.id, name:res.biz.name, desc:res.biz.desc};
            if(undefined != res.biz.modules && null != res.biz.modules && res.biz.modules.length > 0){
              let modules=[];
              res.biz.modules.forEach(function (e){
                modules.push(e.code);
              });

              self.selected = modules;
              self.modules = modules;
            }
          }
        } else {
          self.$message.error(res.msg.message, 2);
        }
      }, function (res) {
      });
    },
    children:function (children){
      const self = this;
      let result=[];
      if(undefined != children && null != children && children.length > 0){
        children.forEach(function (item, index) {
          if(undefined == item || null == item.children || item.children.length <=0){
            result.push({key: item.id, value: item.id, type:'L', title:item.name, children:[]});
          }else{
            result.push({key: item.id, value: item.id, type:'L', title:item.name, children:self.children(item.children)});
          }
        });
      }
      return result;
    },
    searchAction: function () {
      const self = this;
      this.grid.loading = true;
      this.$axios.get('/api/clinic/roles').then(function (res) {
        self.grid.loading = false;
        if (res.msg.flag == 0) {
          if(null == res.biz || res.biz.empty){
            self.$message.info({content: res.msg.message, duration: 2});
            Object.assign(self.grid, {data: []});
          }else{
            Object.assign(self.grid, {data: res.biz});
          }
        } else {
          self.$message.error(res.msg.message, 2);
        }
      }, function (res) {
        self.grid.loading = false;
      });
    }
  }
}
const columns=[
  {
    title: '序号',
    align: 'center',
    scopedSlots: { customRender: 'index'},
    width: 60
  },
  {
    title: '角色名称',
    dataIndex: 'name',
    key: 'name',
    width: 100,
    customRender:(text, record, index) =>{
      return text == undefined || text == null || text == '' ? '-' : text;
    }
  },
  {
    title: '角色描述',
    dataIndex: 'desc',
    key: 'desc',
    width: 100,
    customRender:(text, record, index) =>{
      return text == undefined || text == null || text == '' ? '-' : text;
    }
  },
  {
    title: '状态',
    align: 'center',
    dataIndex: 'statusName',
    key: 'statusName',
    width: 100,
    customRender:(text, record, index) =>{
      return text == undefined || text == null || text == '' ? '-' : text;
    }
  },
  {
    title: '操作',
    key: 'operate',
    align: 'center',
    width: 100,
    scopedSlots: { customRender: 'operate'}
  }
];
</script>

<style scoped>

</style>
